import { Service } from '../index'
//获取官网咨询人员列表
export const setContactInfo = (data) => {
    return Service({
        url: 'api/websiteContact',
        method: 'post',
        data
    })
}